import styled from "styled-components";

export const EditTournamentBaseWrapper = styled.div`
  display: flex;
  gap: 20px;
  position: relative;
`;

export const EditTournamentInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
`;

export const EditTournamentInputBox = styled.div`
  display: flex;
  gap: 30px;
  position: relative;
  align-items: center;
  width: max-content;

  > .name {
    font-family: Pretendard;
    font-weight: 600;
    font-size: 20px;
    width: 169px;
    color: #121212;
  }

  > input {
    width: 290px;
    height: 22px;
    border-radius: 2.7px;
    padding: 5px 8px;
    border: 0.67px solid var(--Black-200, #b7b7b7);
    outline: none;
    font-family: Pretendard;
    font-weight: 500;
    font-size: 10.79px;
  }

  > span {
    position: absolute;
    right: 8px;
    top: 12px;
    font-family: Pretendard;
    font-weight: 500;
    font-size: 10.79px;
    color: #808080;
  }
`;

export const EditTournamentSettingWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  gap: 15px;
  height: 468px;
`;

export const EditTournamentSettingBox = styled.div<{ height?: string }>`
  background: #f0f0f0;
  padding: 15px;
  border-radius: 8px;
  width: 315px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  ${({ height }) => `height: ${height}`};
  position: relative;
`;

export const EditTournamentSettingInputBox = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  > .name {
    font-family: Pretendard;
    font-weight: 600;
    font-size: 15px;
    width: 70px;
  }

  > input {
    width: 100px;
    height: 20px;
    border-radius: 2.7px;
    padding: 5px 8px;
    border: 0.67px solid var(--Black-200, #b7b7b7);
    outline: none;
    font-family: Pretendard;
    font-weight: 500;
    font-size: 10.79px;
  }

  > span {
    font-family: Pretendard;
    font-weight: 400;
    font-size: 15px;
  }
`;

export const EditTournamentSettingTitle = styled.div`
  color: #1a191a;
  font-family: Pretendard;
  font-weight: 600;
  font-size: 17px;
  display: flex;
  align-items: center;
  gap: 10px;
  height: 24px;

  > img {
    cursor: pointer;
  }
`;

export const EditTournamentSettingPagination = styled.div`
  color: #b7b7b7;
  font-family: Pretendard;
  font-weight: 700;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: 10px;
  position: absolute;
  bottom: 20px;

  > .page {
    text-align: center;
    width: 30px;
  }

  > img {
    cursor: pointer;
  }
`;
